import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import Logout from '@/components/Logout.vue'
import OrderStatus from '@/components/OrderStatus.vue'
import OrderStatusDetail from '@/components/OrderStatusDetail.vue'
import OrderStatusView from '@/components/OrderStatusView.vue'
import SyncOrder from '@/components/SyncOrder.vue'
import SyncProduct from '@/components/SyncProduct.vue'
import BackupTasks from '@/components/BackupTasks.vue'
import ProcessOrders from '@/components/ProcessOrders.vue'
import UnsyncedOrders from '@/components/UnsyncedOrders.vue'
import SageConfig from '@/components/SageConfig.vue'
import Webhooks from '@/components/Webhooks.vue'
import Unauthorized from '@/components/Unauthorized'
import NotFound from '@/components/NotFound.vue'
import RedisQueue from '../components/RedisQueue.vue'


const routes = [
  { path: '/', component: Home },
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/order_status', component: OrderStatus },
  {
    path: '/order_status_view',
    component: OrderStatusView,
    children: [
      {
        path: ':order_id',
        component: OrderStatusDetail
      }
    ]
  },
  { path: '/sync_order', component: SyncOrder },
  { path: '/sync_product', component: SyncProduct },
  { path: '/backup_tasks', component: BackupTasks },
  { path: '/process_orders', component: ProcessOrders },
  { path: '/unsynced_orders', component: UnsyncedOrders },
  { path: '/sage_config', component: SageConfig },
  { path: '/webhooks', component: Webhooks },
  { path: '/unauthorized', component: Unauthorized },
  { path: '/redis_queue', component: RedisQueue },
  { path: '*', component: NotFound }
]

Vue.use(Router)

export default new Router({
  routes,
  mode: 'history'
})
